import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { sweetAlert } from 'src/app/utils/swal';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { PushToTalkService } from '../push-to-talk-service/push-to-talk.service';
import { AudioService } from 'src/app/service/audio-service/audio.service';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { ProTipsServiceService } from '../../helping-material/nemt-pro-tips/service/pro-tips-service.service';
import { StaffService } from '../../staffs/staff-service/staff.service';

@Component({
  selector: 'app-push-to-talk',
  templateUrl: './push-to-talk.component.html',
  styleUrls: ['./push-to-talk.component.css']
})
export class PushToTalkComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('messageTone', { static: true }) messageTone: ElementRef;
  @ViewChildren('audioPlayer') audioPlayers!: QueryList<ElementRef<HTMLAudioElement>>;

  isSound = true;
  driverList = [];
  driverSms = [];
  endPoint = null;
  searchDriver: any;
  searchMessages: any;
  newMessage = null;
  user;
  selectedGroup;
  driverId;
  driverName: string | null = null;
  private driverAutoSelectAttempted = false;
  groupList = [];
  filteredGroupList = [];
  preDriverList;
  groupModal;
  editGroupObj;
  staffList = [];
  preStaffList = {};
  groupStatus = 'active';

  isRecording = false;
  audioUrl: string | null = null;
  viewers;

  constructor(
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pushToTalk: PushToTalkService,
    private audioService: AudioService,
    private proTips: ProTipsServiceService,
    private staffService: StaffService
  ) { }

  ngOnInit() {
    this.getUser();
    this.driverId = history.state.id
    this.driverName = history.state.name || null;
    this.endPoint = this.activatedRoute.snapshot.url[1].path;
    this.getDriverList();
    this.getStaffList();

  }

  ngAfterViewInit() {
    if (!this.audioPlayers) {
      console.error('No audio players found');
      return;
    }

    // Add listeners for initial players
    this.addListenersToPlayers(this.audioPlayers);

    // Listen for updates to the QueryList
    this.audioPlayers.changes.subscribe((players: QueryList<ElementRef<HTMLAudioElement>>) => {

      // Remove listeners from old players
      this.removeListenersFromPlayers(this.audioPlayers);

      // Add listeners to updated players
      this.addListenersToPlayers(players);
    });
  }

  addListenersToPlayers(players: QueryList<ElementRef<HTMLAudioElement>>) {
    players.forEach((audioPlayer) => {
      const playerElement = audioPlayer.nativeElement;

      playerElement.addEventListener('play', this.handlePlay);
      playerElement.addEventListener('pause', this.handlePause);
      playerElement.addEventListener('ended', this.handleEnded);

    });
  }

  removeListenersFromPlayers(players: QueryList<ElementRef<HTMLAudioElement>>) {
    players.forEach((audioPlayer) => {
      const playerElement = audioPlayer.nativeElement;

      playerElement.removeEventListener('play', this.handlePlay);
      playerElement.removeEventListener('pause', this.handlePause);
      playerElement.removeEventListener('ended', this.handleEnded);

    });
  }



  handlePlay = (event: Event) => {
    const playerElement = event.target as HTMLAudioElement;
    const filtertedSms = this.driverSms.find(item => item._id === playerElement.id);
    if (!(filtertedSms && filtertedSms.sender_id !== this.user._id && filtertedSms.viewers.includes(this.user._id))) {
      this.markAsReadMessage(playerElement.id);
    }

  };


  markAsReadMessage = (pushtotalkmessageId) => {
    this.pushToTalk.markAsReadMessage({ pushtotalkmessageId }).pipe(takeUntil(componentDestroyed(this))).subscribe((data) => {
      if (data) {
        const filtertedSms = this.driverSms.find(item => item._id === data._id);
        if (filtertedSms) {
          filtertedSms.viewers.push(this.user._id);
        }
      }
    })
  };


  isReadMessage = (message) => {
    if (message.viewers.includes(this.user._id)) {
      return true;
    } else {
      return false;
    }
  };




  handlePause = (event: Event) => {
    const playerElement = event.target as HTMLAudioElement;
  };

  handleEnded = (event: Event) => {
    const playerElement = event.target as HTMLAudioElement;
  };

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.setUpDriverAlertSocketListener();
          this.getPushtoTalk();
        }
      });
  }

  getGroupMessages(group?) {
    let queryParams
    if (group) {
      queryParams = {
        pushtotalkgroup: group._id
      }
    }

    this.pushToTalk.getPushToTalkMessages(queryParams).pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        this.driverSms = data
      })
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
          this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }

  getStaffList() {
    // let queryParams = {
    //   status: 'active'
    // };
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.staffList = data
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getImage(userObj) {
    if (userObj.profileImageURL) {
      return userObj.profileImageURL;
    }
    return '/assets/images/placeholders/driver-placeholder.png';
  }

  getDisplayName(userObj) {
    if (userObj.displayName) {
      return userObj.displayName;
    }
    return 'N/A';
  }

  setUpDriverAlertSocketListener() {
    let isStaff = this.user && this.user.sId ? true : false;
    this.socketService.addListener(Events.PUSH_TO_TALK)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (isStaff && data.type === 'cnew') {

            return; // ignore cmessage if received for the company.
          }

          if (this.selectedGroup && data.pushtotalkmessage && (data.pushtotalkmessage.pushtotalkgroup === this.selectedGroup._id)) {
            this.driverSms.push(data.pushtotalkmessage);
            this.markAsReadMessage(data.pushtotalkmessage._id);
          }
        } else {
          sweetAlert('Error', data.message, 'error', 'OK');

        }
      });

  }


  getPushtoTalk() {
    this.pushToTalk.getPushToTalkGroup().pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.groupList = data;
          this.filterList();
        }
      })
  }

  createGroup(operation: any) {
    if (operation === 'add') {
      this.groupModal = {
        drivers: this.driverList,
        staffs: this.staffList
      }
    } else {
      this.groupModal = {
        drivers: this.driverList,
        staffs: this.staffList,
        groupId: this.selectedGroup._id
      }
    }
  }

  selectGroup(driver) {
    this.selectedGroup = driver
    this.getGroupMessages(this.selectedGroup)
  }

  onMessagePlay() {
    this.messageTone.nativeElement.play();

  }

  sendRecording(fileUrl) {
    const payload = {
      pushtotalkgroup: this.selectedGroup._id,
      fileURL: fileUrl
    }
    this.pushToTalk.sendAudioMessage(payload).pipe(takeUntil(componentDestroyed(this))).subscribe((data) => {
      if (data) {
        this.driverSms.push(data)
        this.onMessagePlay();
      }
    })
  }


  startRecording(): void {
    this.isRecording = true;
    this.audioService.startRecording()
      .catch((err) => console.error('Error starting recording:', err));
  }

  stopRecording(): void {
    this.audioService.stopRecording()
      .then(({ file, url }) => {
        this.audioUrl = url;
        this.isRecording = false;
        this.fileProcessing(file)
      })
      .catch((err) => console.error('Error stopping recording:', err));
  }

  playAudio(): void {
    if (this.audioUrl) {
      const audio = new Audio(this.audioUrl);
      audio.play();
    }
  }

  async fileProcessing(file) {
    const data: any = await this.proTips.changeCoverImage(file).toPromise();
    this.sendRecording(data.location)


  }
  closeModal(evt) {
    this.groupModal = null
  }


  updatedData(evt) {
    if (evt.group) {
      this.groupList.push(evt.group)
    } else {
      const item = this.groupList.find((t) => t._id === evt._id);
      if (item) {
        item.name = evt.name;
        item.drivers = evt.drivers;
        item.staffs = evt.staffs;
        item.status = evt.status;
      }

    }
    this.groupModal = null
    this.filterList();
  }

  filterList() {
    this.filteredGroupList = this.groupList.filter((t) => t.status === this.groupStatus);

    // Deep-linked from a driver's card (dashboard call/push-to-talk icons): jump straight into
    // their 1:1 group if one already exists, otherwise just pre-fill the search so it's one click
    // away. Only attempted once so it doesn't fight a selection the user makes afterwards (e.g.
    // when filterList() re-runs from the active/inactive status toggle).
    if (this.driverId && !this.driverAutoSelectAttempted) {
      this.driverAutoSelectAttempted = true;
      const matchedGroup = this.filteredGroupList.find(
        (g: any) => g.drivers && g.drivers.length === 1 && g.drivers[0] === this.driverId
      );
      if (matchedGroup) {
        this.selectGroup(matchedGroup);
        return;
      }
      if (this.driverName) {
        this.searchDriver = this.driverName;
      }
    }

    this.selectGroup(null);
  }

  ngOnDestroy(): void {
    this.removeListenersFromPlayers(this.audioPlayers);
    this.socketService.removeListener(Events.PUSH_TO_TALK);
  }

  openViewerModal(payload:any){
    if(payload)
    this.viewers = { viewer: payload.viewers,staff:this.preStaffList,driver: this.preDriverList, company:this.user}
  }
}
